import { useCallback } from "react";
import { useReactFlow, useUpdateNodeInternals } from "@xyflow/react";
import { isNodeOutOfViewport } from "../Components/Calculations/utils";
import type { Node } from "@xyflow/react";
import type { flowNode } from "../Components/Calculations/CalculationCanvas/CalculationCanvas";

export const useFitViewIfNodesHidden = () => {
    const { getViewport, getNode, fitView } = useReactFlow();
    const updateNodeInternals = useUpdateNodeInternals();

    const checkAndFitAllNodes = useCallback(
        (
            nodes: Node[],
            containerWidth: number,
            containerHeight: number
        ) => {
            if (!nodes?.length) return;

            requestAnimationFrame(() => {
                requestAnimationFrame(() => {

                    // force recalculation
                    nodes.forEach((node) => {
                        updateNodeInternals(node.id);
                    });

                    requestAnimationFrame(() => {

                        const viewport = getViewport();

                        const isAnyHidden = nodes.some((node) => {
                            const nodeData = getNode(node.id) as flowNode | undefined;
                            if (!nodeData) return false;
                            if (!nodeData.measured?.width || !nodeData.measured?.height)
                                return false;

                            return isNodeOutOfViewport(
                                nodeData,
                                viewport,
                                containerWidth,
                                containerHeight
                            );
                        });

                        if (isAnyHidden) {
                            fitView({
                                padding: 0.2,
                                duration: 250,
                            });
                        }
                    });
                });
            });
        },
        [getViewport, getNode, fitView, updateNodeInternals]
    );

    return checkAndFitAllNodes;
};
